export const DsDialogContentOverrides = {
    MuiDialogContent: {
        styleOverrides: {
            root: {
                padding: 'var(--ds-spacing-zero)'
            }
        }
    }
};
